import { useMutation } from '@tanstack/react-query';
import { commonApi, queryClient } from '~/apis';
import { QueryKeyAuth } from '~/apis/auth';

export { useGetAllOIQuery } from '~/apis/common/filter';

export const useTranslateMutation = () => {
  return useMutation(commonApi.translateCreate, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeyAuth, 'user-info']);
    },
  });
};
